import type { Page } from '../../types';

const criminalProsecutionsFraud: Page[] = [
  {
    pageType: 'question',
    title: 'Criminal prosecutions for fraud',
    name: 'criminal-prosecutions-fraud-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any criminal prosecutions for fraud to declare?',
        name: 'prosecutions_criminal_fraud_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Criminal prosecutions for fraud',
    name: 'criminal-prosecutions-fraud',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'prosecutions_criminal_fraud_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were referred?',
        name: 'prosecutions_criminal_fraud_referral',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions proceeded to charge?',
        name: 'prosecutions_criminal_fraud_proceed_charged',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were successful?',
        name: 'prosecutions_criminal_fraud_successful',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'prosecutions_criminal_fraud_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default criminalProsecutionsFraud;




